<template>
  <v-container fluid tag="section">
    <v-dialog
      v-model="alert_infor"
      width="60%"
      class="usuario-dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Logs </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers_log"
            :items="lista_log"
            :items-per-page="5"
            :mobile-breakpoint="960"
            :footer-props="{
              'items-per-page-options': [5],
              'items-per-page-text': 'Registro por página',
            }"
            class="elevation-0"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="alert_infor = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="alert_msg"
      width="500"
      class="usuario-dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Mensagem </v-card-title>

        <v-card-text>
          {{ alert_msg_descricao }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="alert_msg = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dlg_novo"
      max-width="600px"
      class="usuario-dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-toolbar text color="primary" dark> <h3>Novo Usuário</h3> </v-toolbar>

        <v-card-text>
          <v-form ref="form" style="margin-top: 20px" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="signupRequest.nome"
                    style="font-size: 20px"
                    outlined
                    :rules="nameRules"
                    clearable
                    label="Nome Completo"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="signupRequest.telefone"
                    style="font-size: 20px; font-color: red"
                    outlined
                    :rules="nameRules"
                    clearable
                    label="Telefone"
                    v-mask="'(##) #####-####'"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="signupRequest.username"
                    style="font-size: 20px; font-color: red"
                    :counter="50"
                    outlined
                    :rules="emailRules"
                    clearable
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="signupRequest.colaborador.id"
                    style="font-size: 20px; font-color: red"
                    outlined
                    clearable
                    label="Colaborador"
                    required
                    item-text="nome"
                    item-value="id"
                    :items="listaColaboradores"
                    auto-select-first
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="signupRequest.password"
                    style="font-size: 20px; font-color: red"
                    :counter="12"
                    outlined
                    :rules="passRules"
                    clearable
                    type="password"
                    label="Senha"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*campos requeridos</small>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="dlg_novo = false"> Sair </v-btn>
          <v-btn color="success" @click="cadastrar">
            OK
            <v-icon right dark> mdi-check </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dlg_edit"
      max-width="600px"
      class="usuario-dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-toolbar text color="primary" dark>
          <h3>Editar Usuário</h3>
        </v-toolbar>

        <v-card-text>
          <v-form ref="formedit" style="margin-top: 20px" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="signupRequest.nome"
                    style="font-size: 20px"
                    outlined
                    :rules="nameRules"
                    clearable
                    label="Nome Completo"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="signupRequest.telefone"
                    style="font-size: 20px; font-color: red"
                    outlined
                    :rules="nameRules"
                    clearable
                    label="Telefone"
                    v-mask="'(##) #####-####'"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="signupRequest.username"
                    style="font-size: 20px; font-color: red"
                    :counter="50"
                    outlined
                    :rules="emailRules"
                    clearable
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="signupRequest.colaborador.id"
                    style="font-size: 20px; font-color: red"
                    outlined
                    clearable
                    label="Colaborador"
                    required
                    item-text="nome"
                    item-value="id"
                    :items="listaColaboradores"
                    auto-select-first
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
            <small>*campos requeridos</small>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="dlg_edit = false"> Sair </v-btn>
          <v-btn color="success" @click="editar">
            OK
            <v-icon right dark> mdi-check </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dlg_permissao"
      max-width="1000"
      scrollable
      class="usuario-dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-toolbar text color="primary" dark>
          <h3>Lista Permissões</h3>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-text-field
              v-model="searchRoles"
              label="Buscar permissões"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
            />
            <v-row>
              <v-data-table
                :single-select="false"
                :loading="loading_roles"
                :items-per-page="rolesTableOptions.itemsPerPage"
                :options.sync="rolesTableOptions"
                :mobile-breakpoint="960"
                :footer-props="{
                  'items-per-page-options': [30, 50, 100],
                  'items-per-page-text': 'Permissões por página',
                }"
                :headers="headers_roles"
                v-model="user.newrole"
                :items="roles"
                :search="searchRoles"
                show-select
                item-key="id"
                class="elevation-0 permissoes-table"
              >
              </v-data-table>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="dlg_permissao = false">
            Sair
          </v-btn>
          <v-btn color="success" @click="cadastrar_permissao()">
            OK
            <v-icon right dark> mdi-check </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <base-material-card
      icon="mdi-account"
      title="Usuários Cadastrados"
      class="px-5 py-3"
    >
      <v-row class="mt-4">
        <v-col
          cols="12"
          md="6"
          class="d-flex align-center flex-wrap user-list-actions"
        >
          <v-btn color="success" @click="novo_usuario()">
            NOVO USUÁRIO

            <v-icon right dark> mdi-account-multiple-plus </v-icon>
          </v-btn>

          <v-btn color="orange" @click="getInfor()">
            LOG

            <v-icon right dark> mdi-application-braces-outline </v-icon>
          </v-btn>

          <v-switch
            v-model="somenteAtivos"
            label="Listar somente ativos"
            class="ml-4 mt-0"
            hide-details
            dense
          />
        </v-col>
        <v-col cols="12" md="6" class="user-search"
          ><v-text-field
            v-model="search"
            label="Filtrar usuário"
            outlined
            dense
            clearable
            class="mb-3"
            append-icon="mdi-filter"
        /></v-col>
      </v-row>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="usuariosExibidos"
        :search="search"
        item-key="id"
        :items-per-page="100"
        :mobile-breakpoint="960"
        hide-default-footer
        class="usuarios-table"
      >
        <template v-slot:item.nome="{ item }">
          {{ item.nome }}
          <br />
          <v-icon> mdi-phone </v-icon>
          {{ item.telefone }}
        </template>

        <template v-slot:item.ativo="{ item }">
          <v-chip class="ma-2" :color="getBadge(item.ativo)" text-color="white">
            {{ getStatus(item.ativo) }}
          </v-chip>
        </template>

        <template v-slot:item.acoes="{ item }">
          <div class="user-action-buttons">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                dark
                :disabled="item.ativo == false"
                small
                :loading="btn_status"
                v-bind="attrs"
                v-on="on"
                @click="editrPerfil(item)"
                color="blue"
              >
                <v-icon dark> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip bottom v-if="item.ativo == false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                small
                :loading="btn_status"
                v-bind="attrs"
                v-on="on"
                @click="mudarStatus(item)"
                color="warning"
              >
                <v-icon dark> mdi-check </v-icon>
              </v-btn>
            </template>
            <span>Habilitar</span>
          </v-tooltip>

          <v-tooltip bottom v-if="item.ativo == true">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                small
                :loading="btn_status"
                v-bind="attrs"
                v-on="on"
                @click="mudarStatus(item)"
                color="red"
              >
                <v-icon dark> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Desabilitar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                :disabled="item.ativo == false"
                small
                :loading="btn_status"
                v-bind="attrs"
                v-on="on"
                @click="ajutarPerfil(item)"
                color="black"
              >
                <v-icon dark> mdi-account-box </v-icon>
              </v-btn>
            </template>
            <span>Perfil</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                :disabled="item.ativo == false"
                small
                :loading="btn_status"
                v-bind="attrs"
                v-on="on"
                @click="enviarSMS(item.id)"
                color="blue"
              >
                <v-icon dark> mdi-send </v-icon>
              </v-btn>
            </template>
            <span>Enviar SMS de Ativação</span>
          </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
import Usuario from "../../services/usuario";
import Roles from "../../services/roles";
import rh from "@/services/rh";
export default {
  created() {
    if (this.$store.state.auth.status.loggedIn == false) {
      this.$router.push("/");
    }
  },

  data: () => ({
    nameRules: [
      (v) => !!v || "Campo Obrigatório",
      (v) => (v && v.length >= 4) || "Usuário deve ter pelo menos 6 caracteres",
      (v) => (v && v.length <= 30) || "Usuário deve ter pelo até 30 caracteres",
    ],

    emailRules: [
      (v) => !!v || "Campo Obrigatório",
      (v) => (v && v.length >= 5) || "Email deve ter pelo menos 5 caracteres",
      (v) => (v && v.length <= 50) || "Email deve ter pelo até 50 caracteres",
    ],

    passRules: [
      (v) => !!v || "Campo Obrigatório",
      (v) => (v && v.length >= 6) || "Senha deve ter pelo menos 6 caracteres",
      (v) => (v && v.length <= 12) || "Senha deve ter pelo até 12 caracteres",
    ],

    headers_roles: [
      { text: "Permissão", value: "name" },
      { text: "Menu", value: "menu" }, // Coluna modificada
      { text: "Descrição", value: "descricao" }, // Coluna modificada
    ],

    usuarios: [],
    select_roles: [],
    dlg_novo: false,
    dlg_edit: false,
    btn_status: false,
    dlg_permissao: false,
    loading_roles: false,
    alert_msg: false,
    alert_msg_descricao: "",
    lista_log: [],
    alert_infor: false,
    headers_log: [
      { text: "Administrador", value: "user" },
      { text: "Usuário", value: "usuario" },
      { text: "Data", value: "data_insert" },
      { text: "Ação", value: "acao" },
      { text: "Valor", value: "valor" },
    ],
    user: {
      id: "",
      newrole: [],
    },
    roles: [],
    rolesTableOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
    },
    authority: [],
    loading: false,
    selected: [],
    signupRequest: {
      id: "",
      username: "",
      nome: "",
      telefone: "",
      password: "",
      colaborador: {
        id: 0,
      },
    },
    listaColaboradores: [],
    dlg_novo: false,
    msg_dialog: "",
    dialog: false,
    checkboxNames: ["01", "02", "03", "04"],
    search: "",
    searchRoles: "",
    somenteAtivos: false,
    headers: [
      {
        text: "Nome",
        value: "nome",
        width: "30%",
      },
      { text: "Email", value: "email", width: "20%" },
      { text: "Acesso", value: "acesso_now", width: "6%" },
      { text: "Situação", value: "ativo", width: "6%" },
      { text: "Ações", value: "acoes", sortable: false, width: "40%" },
    ],
  }),

  mounted() {
    this.listar();
    this.listarRoles();
    //this.clear();
    this.consultar_colaboradores();
  },

  computed: {
    usuariosExibidos() {
      if (!this.somenteAtivos) {
        return this.usuarios;
      }

      return this.usuarios.filter((usuario) => usuario.ativo === true);
    },
  },

  methods: {
    ordernColaboradores(lista) {
      lista.sort((a, b) => {
        if (a.nome < b.nome) return -1;
        if (a.nome > b.nome) return 1;
        return 0;
      });
    },
    consultar_colaboradores() {
      rh.lista_colaboradores_ativos()
        .then((response) => {
          this.listaColaboradores = response.data;
          this.ordernColaboradores(this.listaColaboradores);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    listar() {
      this.loading = true;

      Usuario.lista()
        .then((response) => {
          this.usuarios = response.data;
        })
        .catch((e) => {})
        .finally(() => {
          this.loading = false;
        });
    },

    userPermissao(id) {
      Roles.user(id)
        .then((response) => {
          this.user.newrole = response.data;
        })
        .catch((e) => {})
        .finally(() => {
          this.dlg_permissao = true;
        });
    },

    listarRoles() {
      //this.loading_roles = true;
      Roles.lista()
        .then((response) => {
          this.roles = response.data;
        })
        .catch((e) => {
          this.loading_roles = false;
        })
        .finally(() => {
          this.loading_roles = false;
        });
    },

    clear() {
      this.$refs.form.reset();
    },

    novo_usuario() {
      this.dlg_novo = true;
    },

    cadastrar_permissao() {
      Usuario.updatePermissao(this.user.id, this.user.newrole)
        .then((response) => {
          this.user = {};
          if (response.status === 200) {
            this.alert_msg = true;
            this.alert_msg_descricao = "Atualizado com sucesso";
            this.dlg_permissao = false;
          }
        })
        .catch((e) => {
          if (e.response.status === 403) {
            alert("Usuário não tem permissão");
          }
        })
        .finally(() => {});
    },

    cadastrar() {
      if (this.$refs.form.validate()) {
        Usuario.cadastro(this.signupRequest)
          .then((response) => {
            this.alert_msg = true;
            if (response.status === 200) {
              this.usuarios.push(response.data);
              this.alert_msg_descricao = "Cadastrado com Sucesso";
            }

            this.dlg_novo = false;
          })
          .catch((e) => {
            this.dlg_novo = false;
            this.alert_msg = true;
            this.alert_msg_descricao = "Usuário ou email já existem";

            if (e.response.status === 403) {
              alert("Usuário não tem permissão");
            }
          })
          .finally(() => {
            this.dlg_novo = false;
            (this.signupRequest.username = ""),
              (this.signupRequest.telefone = ""),
              (this.signupRequest.password = "");
            (this.signupRequest.nome = ""), (this.signupRequest.id = "");
          });
      }
    },

    editar() {
      if (this.$refs.formedit.validate()) {
        Usuario.editar(this.signupRequest)
          .then((response) => {
            this.alert_msg = true;
            if (response.status === 200) {
              this.alert_msg_descricao =
                (response.data && response.data.mensagem) ||
                "Atualizado com sucesso";
            }

            this.dlg_edit = false;
          })
          .catch((e) => {
            this.dlg_edit = false;
            this.alert_msg = true;
            this.alert_msg_descricao = "Usuário ou email já existem";

            if (e.response && e.response.status === 403) {
              alert("Usuário não tem permissão");
            }
          })
          .finally(() => {
            this.dlg_edit = false;
            (this.signupRequest.username = ""),
              (this.signupRequest.telefone = ""),
              (this.signupRequest.password = "");
            (this.signupRequest.nome = ""), (this.signupRequest.id = "");
            this.listar();
          });
      }
    },
    mudarStatus(item) {
      this.btn_status = true;
      Usuario.updateStatusUsuario(item.id)
        .then((response) => {
          const index = this.usuarios.findIndex((u) => u.id === item.id);
          if (index !== -1) {
            this.$set(this.usuarios, index, {
              ...this.usuarios[index],
              ativo: response.data,
            });
          } else {
            item.ativo = response.data;
          }
        })
        .catch((e) => {
          console.error("Erro ao atualizar status do usuário:", e);
        })
        .finally(() => {
          this.btn_status = false;
        });
    },

    ajutarPerfil(item) {
      this.user = {
        ...item,
        newrole: [],
      };
      this.userPermissao(item.id);
    },

    editrPerfil(item) {
      this.signupRequest.nome = item.nome;
      this.signupRequest.id = item.id;
      this.signupRequest.username = item.email;
      this.signupRequest.telefone = item.telefone;

      // Inicializa o objeto colaborador se não existir
      if (!this.signupRequest.colaborador) {
        this.signupRequest.colaborador = {};
      }

      // Define o ID do colaborador se existir no item
      if (item.colaborador && item.colaborador.id) {
        this.signupRequest.colaborador.id = item.colaborador.id;
      } else {
        this.signupRequest.colaborador.id = null;
      }

      this.dlg_edit = true;
    },

    enviarSMS(id) {
      this.btn_status = true;

      Usuario.smsAtivacao(id)
        .then((response) => {
          this.user = {};
          if (response.status === 200) {
            this.alert_msg = true;
            this.alert_msg_descricao = response.data.mensagem;
            this.dlg_permissao = false;
          } else {
            this.alert_msg = true;
            this.alert_msg_descricao = response.data.mensagem;
          }
        })
        .catch((e) => {
          if (e.response.status === 403) {
            this.alert_msg = true;
            this.alert_msg_descricao = "Usuário não tem permissão";
          }
        })
        .finally(() => {
          this.btn_status = false;
        });
    },

    getInfor() {
      this.alert_infor = true;

      Usuario.logs()
        .then((response) => {
          if ((response.status = 200)) {
            this.lista_log = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {});
    },

    setDisabled: function (status) {
      return status;
    },

    setEnable: function (status) {
      return !status;
    },

    getBadge(status) {
      switch (status) {
        case true:
          return "green lighten-3";
        case false:
          return "red lighten-2";
        default:
          "success";
      }
    },

    getStatus(status) {
      switch (status) {
        case true:
          return "Ativo";
        case false:
          return "Inativo";
        default:
          "";
      }
    },
  },
};
</script>

<style scoped>
.permissoes-table {
  width: 100%;
}

.user-action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.user-action-buttons .v-btn {
  margin: 0 !important;
}

@media (max-width: 959px) {
  .user-list-actions {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }

  .user-list-actions .v-btn {
    justify-content: center;
    margin: 0 !important;
    width: 100%;
  }

  .user-list-actions .v-input--switch {
    margin-left: 0 !important;
    margin-top: 8px !important;
  }

  .user-search {
    padding-top: 0 !important;
  }

  .user-action-buttons {
    gap: 6px;
  }

  .user-action-buttons .v-btn {
    height: 36px !important;
    min-width: 36px !important;
    width: 36px !important;
  }

  ::v-deep .usuario-dialog.v-dialog--fullscreen {
    margin: 0;
  }

  ::v-deep .usuario-dialog.v-dialog--fullscreen > .v-card {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  ::v-deep .usuario-dialog.v-dialog--fullscreen .v-toolbar__content {
    padding: 0 16px;
  }

  ::v-deep .usuario-dialog.v-dialog--fullscreen .v-card__text {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 16px 12px;
  }

  ::v-deep .usuario-dialog.v-dialog--fullscreen .v-card__actions {
    background: #ffffff;
    border-top: 1px solid #e0e0e0;
    padding: 12px 16px;
  }

  ::v-deep .usuarios-table .v-data-table__mobile-row,
  ::v-deep .permissoes-table .v-data-table__mobile-row {
    align-items: flex-start;
    min-height: 42px;
    padding: 8px 0;
  }

  ::v-deep .usuarios-table .v-data-table__mobile-row__header,
  ::v-deep .permissoes-table .v-data-table__mobile-row__header {
    color: #343f53;
    font-size: 0.75rem;
    font-weight: 600;
    padding-right: 12px;
  }

  ::v-deep .usuarios-table .v-data-table__mobile-row__cell,
  ::v-deep .permissoes-table .v-data-table__mobile-row__cell {
    overflow-wrap: anywhere;
    text-align: right;
  }
}
</style>
